import { combineReducers } from "redux";

import user from "./user";
import carousel from "./carousel";
import family from "./family";
import about from "./about";
import contact from "./contact";
import menu from "./menu";
import products from "./products";
import categories from "./categories";
import sections from "./sections";
import productCategory from "./productCategory";
import mobileNav from "./mobileNav";
import footer from "./footer";
import certificates from "./certificates";
import production from "./production";

export const Store = (state, action) => RootReducer(state, action);

const RootReducer = combineReducers({
  user,
  sections,
  carousel,
  family,
  about,
  contact,
  menu,
  mobileNav,
  products,
  categories,
  productCategory,
  footer,
  certificates,
  production
});
